import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getLabels } from '../labels';
export default function ChunkErrorPage() {
    const labels = getLabels();
    const handleRefresh = () => {
        window.location.reload();
    };
    return (_jsxs("div", { className: "flex min-h-screen flex-col items-center justify-center p-6 text-center", "data-testid": "chunkErrorPage", children: [_jsx("h1", { className: "mb-4 text-2xl font-semibold", children: labels.chunk.title }), _jsx("p", { className: "mb-6 text-gray-600", children: labels.chunk.description }), _jsx("button", { onClick: handleRefresh, className: "bg-brand hover:bg-brand-strong focus:ring-brand-medium rounded-lg px-6 py-3 font-medium text-white focus:ring-2 focus:outline-none", children: labels.chunk.refresh })] }));
}
